export default [
    {
      path: '/support/work_order',
      title: '我的工单',
      key: '我的工单'
    },
    {
      path: '/support/work_order?create=new',
      title: '提交工单',
      key: '提交工单'
    },
  ];
  